import React from 'react';
import { createRoot } from 'react-dom/client';
import AdminDialog from '../components/AdminDialog';

function mount(props) {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const root = createRoot(container);

  return new Promise(resolve => {
    const cleanup = (result) => {
      setTimeout(() => { root.unmount(); document.body.removeChild(container); }, 250);
      resolve(result);
    };
    root.render(
      <AdminDialog
        {...props}
        onConfirm={() => cleanup(true)}
        onCancel={() => cleanup(false)}
      />
    );
  });
}

export const showConfirm = (message, title)         => mount({ message, title, type: 'confirm' });
export const showDelete  = (message, title='Delete') => mount({ message, title, type: 'delete' });
export const showAlert   = (message, title, type='error') => mount({ message, title, type, isAlert: true });
export const showSuccess = (message, title='Done')   => mount({ message, title, type: 'success', isAlert: true });
